import { API_ENDPOINT_GET_AGENT_BATCH, API_ENDPOINT_PUT_AGENT_BATCH } from '../config'
import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const GET_AGENT_BATCH_REQUEST = 'GET_AGENT_BATCH_REQUEST'
export const GET_AGENT_BATCH_SUCCESS = 'GET_AGENT_BATCH_SUCCESS'
export const GET_AGENT_BATCH_FAILURE = 'GET_AGENT_BATCH_FAILURE'

export const PUT_AGENT_BATCH_REQUEST = 'PUT_AGENT_BATCH_REQUEST'
export const PUT_AGENT_BATCH_SUCCESS = 'PUT_AGENT_BATCH_SUCCESS'
export const PUT_AGENT_BATCH_FAILURE = 'PUT_AGENT_BATCH_FAILURE'
export const PUT_AGENT_BATCH_CLEAR_MESSAGE = 'PUT_AGENT_BATCH_CLEAR_MESSAGE'

export const getAgentBatch = (count) => ({
  [CALL_API]: {
    endpoint: `${API_ENDPOINT_GET_AGENT_BATCH}?count=${count}`,
    types: [GET_AGENT_BATCH_REQUEST, GET_AGENT_BATCH_SUCCESS, GET_AGENT_BATCH_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

export const putAgentBatch = (body) => ({
  [CALL_API]: {
    endpoint: `${API_ENDPOINT_PUT_AGENT_BATCH}`,
    types: [PUT_AGENT_BATCH_REQUEST, PUT_AGENT_BATCH_SUCCESS, PUT_AGENT_BATCH_FAILURE],
    method: 'PUT',
    tokenType: API_JWT_TOKEN_NAME,
    body,
  },
})
const clear = () => ({
  type: PUT_AGENT_BATCH_CLEAR_MESSAGE,
})
export const putAgentBatchClearMessage = () => (dispatch) => dispatch(clear())
